export default "__VITE_ASSET__CTVkUjWF__"